import { shape, string, number } from 'prop-types';

export default shape({
  name: string,
  obisCode: string.isRequired,
  unit: string.isRequired,
  scaler: number.isRequired,
  attributeId: number.isRequired,
});
